import { render, staticRenderFns } from "./TabNote.vue?vue&type=template&id=3bf0bc8b&scoped=true&"
import script from "./TabNote.vue?vue&type=script&lang=js&"
export * from "./TabNote.vue?vue&type=script&lang=js&"
import style0 from "./TabNote.vue?vue&type=style&index=0&id=3bf0bc8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf0bc8b",
  null
  
)

export default component.exports